import { render, staticRenderFns } from "./Letsgo.vue?vue&type=template&id=9989a186&scoped=true&"
import script from "./Letsgo.vue?vue&type=script&lang=js&"
export * from "./Letsgo.vue?vue&type=script&lang=js&"
import style0 from "./Letsgo.vue?vue&type=style&index=0&id=9989a186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9989a186",
  null
  
)

export default component.exports